import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { lower } from 'change-case'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { GeneralInformationContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getVendorContacts } from 'ducks/bankGuarantee'
import { isNullOrEmpty } from 'core/utilities'

const GeneralInformation = (props) => {
  const { valueForm={}, change, members, memberLoading, isDisplay=false } = props
  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
  
  useEffect(() => {
    props.getAllMembers(isDisplay)
    // props.getHrmsMembers(isDisplay)
  }, [])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  
  const pmMemberOptions = () => {
    var creatorUser = valueForm.creator || props.username
    var creator = members.find(x => lower(x.username) === lower(creatorUser))
    var lv = creator && creator.goaLevel ? Number(creator.goaLevel) > 5 ? creator.goaLevel : 5 : 5
    return members.filter(x => Number(x.goaLevel) > lv).map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  }

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && !isNullOrEmpty(valueForm.sn) && !isNullOrEmpty(valueForm.requestType)
    } else {
      if (valueForm.creator === props.username) {
        return !isDisplay && !isNullOrEmpty(valueForm.requestType)
      } else {
        return false
      }
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='General Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo) }>
            {showGeneralInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showGeneralInfo}>
        <CardContent>
          <GeneralInformationContainer>
            <div className='rowFields'>
              <Field 
                name='title' 
                label='Title' 
                require 
                editable={editableForm()} 
                type={type.text} 
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='reason' 
                label={valueForm.requestType === 'change' ? 'Reason' : 'Remark'}
                require={valueForm.requestType === 'change'}
                editable={editableForm()} 
                type={type.textArea} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='requesterUser' 
                label='Requester' 
                require
                editable={editableForm()}
                ignoreClearValue={false}
                loading={memberLoading}
                options={memberOptions}
                style={{ marginBottom: '1px' }} 
                type={type.select}
                component={FieldInput} />
              <Field 
                name='projectManagerUser' 
                label='Project Manager/Head BU' 
                require
                editable={editableForm()}
                ignoreClearValue={false}
                loading={memberLoading}
                options={pmMemberOptions()} 
                style={{ marginBottom: '1px' }}
                type={type.select}
                component={FieldInput} />
            </div>
            <div className='rowFields' style={{ flexDirection: 'row' }}>
              <div style={{ flex: 1 }} />
              <div style={{ flex: 1, fontSize: '1rem', color: '#888' }}>*Head BU ต้องเป็น Twigger/Cambium ขึ้นไป</div>
            </div>
            {
              valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null ?
                <div className='rowFields'>
                  <Field 
                    name='submittedDate' 
                    label='Submitted Date' 
                    editable={false}
                    type={type.dateTime}
                    component={FieldInput} />
                  <Field 
                    name='modifiedDate'  
                    label='Modified Date' 
                    editable={false}
                    type={type.dateTime}
                    component={FieldInput} />
                </div>
              : null
            }
          </GeneralInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    members: state.member.members,
    memberLoading: state.member.memberLoading,
  })
}
  
const mapDispatchToProps = {
  getHrmsMembers,
  getVendorContacts,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)